import React, { useState } from 'react';

const EventCard = ({ image, date, title, description, features, icon }) => {
  const [showFeatures, setShowFeatures] = useState(false);

  const toggleFeatures = () => {
    setShowFeatures(!showFeatures);
  };

  return (
    <div className="group bg-white/90 backdrop-blur-sm rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 overflow-hidden transform hover:-translate-y-2 border border-white/20">
      {/* Image Container */}
      <div className="relative h-48 overflow-hidden">
        <img 
          src={image} 
          alt={title} 
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent"></div>
        <div className="absolute top-4 left-4">
          <span className="bg-white/95 backdrop-blur-sm text-brand-dark text-xs font-semibold px-3 py-1 rounded-full shadow-sm">
            {date}
          </span>
        </div>
        <div className="absolute top-4 right-4">
          <span className="text-2xl">{icon}</span>
        </div>
      </div>
      
      {/* Content */}
      <div className="p-6 space-y-4">
        <h3 className="text-2xl font-bold text-gray-800 group-hover:text-brand-primary transition-colors">
          {title}
        </h3>
        <p className="text-gray-600 text-base leading-relaxed">
          {description}
        </p>
        
        {/* Features List - Hidden by default, shown on click */}
        {features && showFeatures && (
          <div className="space-y-3 animate-fadeIn">
            <div className="border-t border-gray-100 pt-3">
              {/* <h4 className="text-sm font-semibold text-gray-700 mb-3">Tính năng chính:</h4> */}
              <div className="space-y-2">
                                 {features.map((feature, idx) => (
                   <div key={idx} className="flex items-start space-x-3 p-4 bg-gradient-to-r from-brand-primary/10 to-brand-secondary/10 rounded-lg border border-brand-primary/20">
                     <div className="flex-shrink-0 w-6 h-6 bg-gradient-to-r from-brand-primary to-brand-secondary rounded-full flex items-center justify-center">
                       <span className="text-white text-sm font-bold">{idx + 1}</span>
                     </div>
                     <span className="text-base text-gray-700 font-medium">{feature}</span>
                   </div>
                 ))}
              </div>
            </div>
          </div>
        )}
        
        <div className="pt-2">
          <button 
            onClick={toggleFeatures}
            className="text-brand-primary font-semibold text-base hover:text-brand-secondary transition-colors flex items-center group"
          >
            <span>{showFeatures ? 'Ẩn chi tiết' : 'Xem chi tiết'}</span>
            <svg 
              className={`w-5 h-5 ml-2 transition-transform duration-300 ${showFeatures ? 'rotate-180' : 'group-hover:translate-x-1'}`} 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default EventCard; 